export default {
  'pages.login.success': '登录成功！',
  'pages.login.failure': '登录失败，请重试！',
  'pages.login.username.placeholder': '用户名',
  'pages.login.username.required': '请输入用户名!',
  'pages.login.password.placeholder': '密码',
  'pages.login.password.required': '请输入密码！',
  'pages.login.rememberMe': '记住我',
  'pages.login.forgotPassword': '忘记密码？',
  'pages.login.forgotPasswordInfo': '请联系管理员重置密码',
  'pages.login.submit': '登录',
  'pages.login.back': '返回',
  'pages.login.emailCheck.title': '邮箱验证',
  'pages.login.emailCheck.description': '6位验证码已发送至 {email}',
  'pages.login.emailCheck.sent': '验证码已发送至您的邮箱',
  'pages.login.tfaCheck.title': '双因素认证',
  'pages.login.tfaCheck.description': '请输入认证器应用中的6位验证码',
  'pages.login.verifyCode.submit': '验证',
  'pages.login.verifyCode.invalid': '验证码无效',
  'pages.login.oidc.divider': '或使用以下方式登录',
  'pages.login.oidc.continueWith': '使用 {provider} 继续',
  'pages.login.oidc.authFailed': 'OIDC登录失败',
  'pages.devices.list': '设备列表',
  'pages.devices.os': '操作系统',
  'pages.devices.status': '状态',
  'pages.devices.user': '用户',
  'pages.devices.deviceGroup': '设备组',
  'pages.devices.note': '备注',
  'pages.devices.online': '在线',
  'pages.devices.offline': '离线',
  'pages.devices.days': '天',
  'pages.devices.hours': '小时',
  'pages.devices.minutes': '分钟',
  'pages.devices.justNow': '刚刚',
  'pages.devices.enable': '启用',
  'pages.devices.disable': '禁用',
  'pages.devices.enableSuccess': '设备已启用',
  'pages.devices.enableFailed': '启用设备失败',
  'pages.devices.disableSuccess': '设备已禁用',
  'pages.devices.disableFailed': '禁用设备失败',
  'pages.devices.deleteSuccess': '设备已删除',
  'pages.devices.deleteFailed': '删除设备失败',
  'pages.devices.deleteConfirm': '确定要删除此设备吗？',
  'pages.devices.deviceInfo': '用户名@设备名',
  'pages.devices.strategyInfo': '策略信息',
  'pages.devices.device': '设备',
  'pages.devices.strategy': '策略',
  'pages.devices.info': '信息',
  'pages.devices.statusNormal': '正常',
  'pages.devices.statusDisabled': '已禁用',
  'pages.devices.onlineStatus': '在线状态',
  'pages.devices.deviceGroupSearchTip': '按设备组名称筛选',
  'pages.devices.remove': '移除',
  'pages.devices.removeFromGroupSuccess': '设备已从组中移除',
  'pages.devices.removeFromGroupFailed': '从组中移除设备失败',
  'pages.devices.removeFromGroupConfirm': '确定要从组中移除此设备吗？',
  'pages.devices.batchRemove': '批量移除',
  'pages.devices.batchRemoveFromGroupSuccess': '成功从组中移除 {count} 个设备',
  'pages.devices.batchRemoveFromGroupFailed': '从组中移除设备失败',
  'pages.devices.batchRemoveFromGroupConfirm': '确定要从组中移除选中的设备吗？',
  'pages.devices.batchEnable': '批量启用',
  'pages.devices.batchDisable': '批量禁用',
  'pages.devices.batchEnableConfirm': '确定要启用选中的设备吗？',
  'pages.devices.batchDisableConfirm': '确定要禁用选中的设备吗？',
  'pages.devices.batchEnableSuccess': '成功启用 {count} 个设备',
  'pages.devices.batchEnableFailed': '启用设备失败',
  'pages.devices.batchEnablePartialFailed':
    '成功启用 {success} 个设备，{failed} 个失败',
  'pages.devices.batchDisableSuccess': '成功禁用 {count} 个设备',
  'pages.devices.batchDisableFailed': '禁用设备失败',
  'pages.devices.batchDisablePartialFailed':
    '成功禁用 {success} 个设备，{failed} 个失败',
  'pages.devices.edit': '编辑设备',
  'pages.devices.updateSuccess': '设备已更新',
  'pages.devices.updateFailed': '更新设备失败',
  'pages.devices.selectUser': '选择用户',
  'pages.devices.selectDeviceGroup': '选择设备组',
  'pages.devices.selectStrategy': '选择策略',
  'pages.addressBook.name': '名称',
  'pages.addressBook.note': '备注',
  'pages.addressBook.shared': '共享地址簿',
  'pages.addressBook.create': '创建地址簿',
  'pages.addressBook.edit': '编辑地址簿',
  'pages.addressBook.personal': '个人地址簿',
  'pages.addressBook.currentAddressBook': '地址簿',
  'pages.addressBook.myAddressBook': '我的地址簿',
  'pages.addressBook.loadFailed': '加载地址簿失败',
  'pages.addressBook.addPeer': '按 ID 添加',
  'pages.addressBook.addTag': '添加标签',
  'pages.addressBook.tagName': '标签名称',
  'pages.addressBook.tagAdded': '标签已添加',
  'pages.addressBook.tagAddFailed': '添加标签失败',
  'pages.addressBook.tagDeleted': '标签已删除',
  'pages.addressBook.tagDeleteFailed': '删除标签失败',
  'pages.addressBook.deleteTagConfirm': '确定要删除此标签吗？',
  'pages.addressBook.tagModeUnion': '任一',
  'pages.addressBook.tagModeIntersection': '全部',
  'pages.addressBook.importDevices': '从设备导入',
  'pages.addressBook.importSuccess': '成功导入 {count} 个设备',
  'pages.addressBook.importPartialFailed': '{count} 个设备导入失败',
  'pages.addressBook.createSuccess': '地址簿已创建',
  'pages.addressBook.createFailed': '创建地址簿失败',
  'pages.addressBook.updateSuccess': '地址簿已更新',
  'pages.addressBook.updateFailed': '更新地址簿失败',
  'pages.addressBook.deleteSuccess': '地址簿已删除',
  'pages.addressBook.deleteFailed': '删除地址簿失败',
  'pages.addressBook.deleteConfirm': '确定要删除此地址簿吗？',
  'pages.addressBook.batchDeleteConfirm': '确定要删除选中的地址簿吗？',
  'pages.addressBook.device': '设备',
  'pages.addressBook.alias': '别名',
  'pages.addressBook.tags': '标签',
  'pages.addressBook.peerAdded': '设备已添加',
  'pages.addressBook.peerAddFailed': '添加设备失败',
  'pages.addressBook.peerDeleted': '设备已删除',
  'pages.addressBook.peerDeleteFailed': '删除设备失败',
  'pages.addressBook.deletePeerConfirm': '确定要删除此设备吗？',
  'pages.addressBook.import': '从设备导入',
  'pages.addressBook.recycleBin': '回收站',
  'pages.deviceGroups.list': '设备组列表',
  'pages.deviceGroups.name': '名称',
  'pages.deviceGroups.note': '备注',
  'pages.deviceGroups.create': '创建设备组',
  'pages.deviceGroups.edit': '编辑设备组',
  'pages.deviceGroups.createSuccess': '设备组已创建',
  'pages.deviceGroups.createFailed': '创建设备组失败',
  'pages.deviceGroups.updateSuccess': '设备组已更新',
  'pages.deviceGroups.updateFailed': '更新设备组失败',
  'pages.deviceGroups.deleteSuccess': '设备组已删除',
  'pages.deviceGroups.deleteFailed': '删除设备组失败',
  'pages.deviceGroups.deleteConfirm': '确定要删除此设备组吗？',
  'pages.deviceGroups.import': '导入',
  'pages.deviceGroups.importDevices': '导入设备',
  'pages.deviceGroups.importSuccess': '成功导入 {count} 个设备',
  'pages.deviceGroups.importFailed': '导入设备失败',
  'pages.users.list': '用户列表',
  'pages.users.name': '用户名',
  'pages.users.displayName': '显示名称',
  'pages.users.email': '邮箱',
  'pages.users.note': '备注',
  'pages.users.status': '状态',
  'pages.users.create': '创建用户',
  'pages.users.enable': '启用',
  'pages.users.disable': '禁用',
  'pages.users.enableSuccess': '用户已启用',
  'pages.users.enableFailed': '启用用户失败',
  'pages.users.disableSuccess': '用户已禁用',
  'pages.users.disableFailed': '禁用用户失败',
  'pages.users.createSuccess': '用户已创建',
  'pages.users.createFailed': '创建用户失败',
  'pages.users.deleteSuccess': '用户已删除',
  'pages.users.deleteFailed': '删除用户失败',
  'pages.users.deleteConfirm': '确定要删除此用户吗？',
  'pages.audits.conn': '连接审计',
  'pages.audits.file': '文件传输日志',
  'pages.audits.alarm': '告警审计',
  'pages.audits.console': '控制台审计',
  'pages.audits.requestedAt': '请求时间',
  'pages.audits.establishedAt': '建立时间',
  'pages.audits.closedAt': '关闭时间',
  'pages.audits.from': '来源',
  'pages.audits.fromName': '来源名称',
  'pages.audits.to': '目标',
  'pages.audits.toName': '目标名称',
  'pages.audits.action': '操作',
  'pages.audits.time': '时间',
  'pages.audits.alarmType': '告警类型',
  'pages.audits.user': '用户',
  'pages.audits.detail': '详情',
  'pages.audits.type': '类型',
  'pages.audits.connType.remoteDesktop': '远程桌面',
  'pages.audits.connType.fileTransfer': '文件传输',
  'pages.audits.connType.portTransfer': '端口转发',
  'pages.audits.connType.viewCamera': '查看摄像头',
  'pages.audits.connType.terminal': '终端',
  'pages.audits.connType.notLoggedIn': '未登录',
  'pages.audits.duration': '持续时间',
  'pages.audits.note': '备注',
  'pages.audits.disconnect': '断开连接',
  'pages.audits.disconnectSuccess': '已成功断开连接！',
  'pages.audits.disconnectFailed': '断开连接失败！',
  'pages.audits.disconnectConfirmTitle': '确认操作',
  'pages.audits.disconnectConfirmTip': '确定要断开此设备的连接吗？',
  'pages.audits.updateSuccess': '更新成功',
  'pages.audits.updateFailed': '更新失败，请重试！',
  'pages.audits.exportCSV': '导出CSV',
  'pages.audits.noDataToExport': '没有数据可导出',
  'pages.audits.exportSuccess': '导出成功',
  'pages.audits.exportFailed': '导出失败',
  'pages.audits.exportConfirmTitle': '导出CSV',
  'pages.audits.exportConfirmContent': '一次最多导出1000条记录，是否继续？',
  'pages.audits.remote': '远程',
  'pages.audits.local': '本地',
  'pages.audits.direction': '方向',
  'pages.audits.files': '个文件',
  'pages.audits.remoteTip': '远程控制的计算机或终端',
  'pages.audits.remoteSearchTip': '按远程设备ID搜索（模糊匹配）',
  'pages.audits.remotePlaceholder': '请输入远程设备ID',
  'pages.audits.pathTip': '远程设备路径',
  'pages.audits.exportCsvTip': '一次最多导出1000条记录',
  'pages.audits.limitedTip': '按大小显示前10个文件',
  'pages.audits.startTime': '开始时间',
  'pages.audits.endTime': '结束时间',
  'pages.audits.alarmType.ipWhitelist': 'IP不在白名单',
  'pages.audits.alarmType.exceedThirtyAttempts': '同一IP超过30次失败尝试',
  'pages.audits.alarmType.sixAttemptsWithinOneMinute': '1分钟内超过6次尝试',
  'pages.audits.alarmType.exceedIpv6PrefixAttempts': 'IPv6前缀尝试次数超限',
  'pages.audits.alarmType.terminalOsLoginBackoff': '终端OS登录被退避阻止',
  'pages.audits.alarmType.terminalOsLoginConcurrency': '终端OS登录并发数超限',
  'pages.common.action': '操作',
  'pages.common.delete': '删除',
  'pages.common.edit': '编辑',
  'pages.common.batchDelete': '批量删除',
  'pages.common.download': '下载',
  'pages.common.more': '更多',
  'pages.404.subTitle': '抱歉，您访问的页面不存在',
  'pages.404.buttonText': '返回首页',
  'pages.customClients.list': '自定义客户端列表',
  'pages.customClients.name': '客户端名称',
  'pages.customClients.createdAt': '创建时间',
  'pages.customClients.create': '创建自定义客户端',
  'pages.customClients.edit': '编辑自定义客户端',
  'pages.customClients.deleteConfirm': '确定要删除此自定义客户端吗？',
  'pages.customClients.createSuccess': '自定义客户端已创建',
  'pages.customClients.createFailed': '创建自定义客户端失败',
  'pages.customClients.updateSuccess': '自定义客户端已更新',
  'pages.customClients.updateFailed': '更新自定义客户端失败',
  'pages.customClients.deleteSuccess': '自定义客户端已删除',
  'pages.customClients.deleteFailed': '删除自定义客户端失败',
  'pages.customClients.downloadFailed': '下载客户端失败',
  'pages.userGroups.list': '用户组列表',
  'pages.userGroups.name': '组名称',
  'pages.userGroups.note': '备注',
  'pages.userGroups.userCount': '用户数',
  'pages.userGroups.create': '创建用户组',
  'pages.userGroups.edit': '编辑用户组',
  'pages.userGroups.deleteConfirm': '确定要删除此用户组吗？',
  'pages.userGroups.createSuccess': '用户组已创建',
  'pages.userGroups.createFailed': '创建用户组失败',
  'pages.userGroups.updateSuccess': '用户组已更新',
  'pages.userGroups.updateFailed': '更新用户组失败',
  'pages.userGroups.deleteSuccess': '用户组已删除',
  'pages.userGroups.deleteFailed': '删除用户组失败',
  'pages.userGroups.loadFailed': '加载用户组失败',
  'pages.userGroups.default': '默认',
  'pages.userGroups.members': '成员',
  'pages.userGroups.membersTitle': '{name} 的成员',
  'pages.userGroups.currentMembers': '当前成员',
  'pages.userGroups.addUsers': '添加用户',
  'pages.userGroups.destination': '目标用户组',
  'pages.userGroups.selectDestination': '选择目标用户组',
  'pages.userGroups.moveSelected': '移动已选用户',
  'pages.userGroups.addSelected': '添加已选用户',
  'pages.userGroups.membersUpdated': '已更新 {count} 个用户',
  'pages.userGroups.membersUpdateFailed': '更新用户组成员失败',
  'pages.users.userGroup': '用户组',
  'pages.users.selectUserGroup': '请选择用户组',
  'pages.addressBook.groupAccess': '用户组权限',
  'pages.addressBook.groupAccessTitle': '{name} 的用户组权限',
  'pages.addressBook.userGroup': '用户组',
  'pages.addressBook.permission': '权限',
  'pages.addressBook.permissionRead': '只读',
  'pages.addressBook.permissionReadWrite': '读写',
  'pages.addressBook.permissionFull': '完全控制',
  'pages.addressBook.addGroupAccess': '添加用户组权限',
  'pages.addressBook.groupAccessLoadFailed': '加载用户组权限失败',
  'pages.addressBook.groupAccessAdded': '用户组权限已添加',
  'pages.addressBook.groupAccessAddFailed': '添加用户组权限失败',
  'pages.addressBook.groupAccessUpdated': '用户组权限已更新',
  'pages.addressBook.groupAccessUpdateFailed': '更新用户组权限失败',
  'pages.addressBook.groupAccessDeleted': '用户组权限已删除',
  'pages.addressBook.groupAccessDeleteFailed': '删除用户组权限失败',
  'pages.addressBook.groupAccessDeleteConfirm': '删除此用户组权限？',
  'pages.addressBook.shareAccess': '共享',
  'pages.addressBook.accessTitle': '{name} - 共享管理',
  'pages.addressBook.shareType': '共享类型',
  'pages.addressBook.shareTarget': '共享对象',
  'pages.addressBook.shareTypeEveryone': '所有人',
  'pages.addressBook.shareTypeUser': '用户',
  'pages.addressBook.shareTypeGroup': '用户组',
  'pages.addressBook.selectUser': '选择用户',
  'pages.addressBook.selectUserPlaceholder': '搜索用户名或邮箱',
  'pages.addressBook.everyoneHint': '所有用户将可以访问此地址簿',
  'pages.addressBook.allUsers': '所有用户',
  'pages.addressBook.addAccess': '添加权限',
  'pages.addressBook.accessLoadFailed': '加载共享权限失败',
  'pages.addressBook.accessAdded': '共享权限已添加',
  'pages.addressBook.accessAddFailed': '添加共享权限失败',
  'pages.addressBook.accessUpdated': '共享权限已更新',
  'pages.addressBook.accessUpdateFailed': '更新共享权限失败',
  'pages.addressBook.accessDeleted': '共享权限已删除',
  'pages.addressBook.accessDeleteFailed': '删除共享权限失败',
  'pages.addressBook.accessDeleteConfirm': '删除此共享权限？',
  'pages.roles.list': '角色列表',
  'pages.roles.name': '角色名称',
  'pages.roles.note': '备注',
  'pages.roles.permissions': '权限',
  'pages.roles.permissionsInfo': '已分配权限数量',
  'pages.roles.create': '创建角色',
  'pages.roles.edit': '编辑角色',
  'pages.roles.deleteConfirm': '确定要删除此角色吗？',
  'pages.roles.selectPermissions': '选择权限',
  'pages.roles.createSuccess': '角色已创建',
  'pages.roles.createFailed': '创建角色失败',
  'pages.roles.updateSuccess': '角色已更新',
  'pages.roles.updateFailed': '更新角色失败',
  'pages.roles.deleteSuccess': '角色已删除',
  'pages.roles.deleteFailed': '删除角色失败',
  'pages.settings.title': '系统设置',
  'pages.settings.save': '保存设置',
  'pages.settings.general': '常规设置',
  'pages.settings.siteName': '站点名称',
  'pages.settings.watermarkEnabled': '用户名水印',
  'pages.settings.adminEmail': '管理员邮箱',
  'pages.settings.language': '默认语言',
  'pages.settings.security': '安全设置',
  'pages.settings.enable2FA': '启用双因素认证',
  'pages.settings.sessionTimeout': '会话超时（分钟）',
  'pages.settings.maxLoginAttempts': '最大登录尝试次数',
  'pages.settings.advanced': '高级设置',
  'pages.settings.logLevel': '日志级别',
  'pages.settings.enableDebugMode': '启用调试模式',
  'pages.settings.fetchFailed': '加载设置失败',
  'pages.settings.saveSuccess': '设置保存成功',
  'pages.settings.saveFailed': '保存设置失败',
  'pages.strategies.list': '策略列表',
  'pages.strategies.name': '策略名称',
  'pages.strategies.note': '备注',
  'pages.strategies.status': '状态',
  'pages.strategies.create': '创建策略',
  'pages.strategies.edit': '编辑策略',
  'pages.strategies.deleteConfirm': '确定要删除此策略吗？',
  'pages.strategies.createSuccess': '策略已创建',
  'pages.strategies.createFailed': '创建策略失败',
  'pages.strategies.updateSuccess': '策略已更新',
  'pages.strategies.updateFailed': '更新策略失败',
  'pages.strategies.deleteSuccess': '策略已删除',
  'pages.strategies.deleteFailed': '删除策略失败',
  'pages.strategies.enterName': '请输入策略名称',
  'pages.strategies.configSummary': '配置摘要',
  'pages.strategies.configCount': '已修改 {modified}/{total} 项',
  'pages.strategies.modifiedAt': '修改时间',
  'pages.strategies.createdAt': '创建时间',
  'pages.strategies.configOptions': '配置选项',
  'pages.strategies.defaultLabel': '默认',
  'pages.strategies.defaultValue': '默认值：{value}',
  'pages.strategies.resetToDefault': '重置为默认值',
  'pages.strategies.modifiedSummary': '已修改 {count} 项配置',
  'pages.strategies.resetAll': '全部重置',
  'pages.strategies.assign': '分配',
  'pages.strategies.assignManagement': '分配管理',
  'pages.strategies.assignDevice': '设备',
  'pages.strategies.assignUser': '用户',
  'pages.strategies.assignDeviceGroup': '设备组',
  'pages.strategies.assignedTargets': '已分配目标',
  'pages.strategies.noAssigned': '暂无已分配目标',
  'pages.strategies.addAssignment': '新增分配',
  'pages.strategies.selectTarget': '请选择目标',
  'pages.strategies.assignSuccess': '策略分配成功',
  'pages.strategies.assignFailed': '策略分配失败',
  'pages.strategies.assignPartialFailed':
    '成功分配 {success} 个目标，{failed} 个失败：{errors}',
  'pages.strategies.unassignSuccess': '策略取消分配成功',
  'pages.strategies.unassignFailed': '策略取消分配失败',
  'pages.strategies.unassignConfirm': '确定要取消分配此目标吗？',
  'pages.strategies.fetchDetailFailed': '获取策略详情失败',
  'pages.strategies.updatedAt': '更新时间',
  'pages.strategies.category.connection': '连接与访问控制',
  'pages.strategies.category.security': '安全与认证',
  'pages.strategies.category.display': '显示与界面',
  'pages.strategies.category.av': '音视频与编解码',
  'pages.strategies.category.file': '文件与剪贴板',
  'pages.strategies.category.advanced': '高级设置',
  'pages.strategies.category.floating': '浮动窗口',
  'pages.strategies.category.privacy': '隐私与录制',
  'pages.strategies.category.hide': '界面隐藏',
  'pages.users.inviteSuccess': '邀请已发送',
  'pages.users.inviteFailed': '发送邀请失败',
  'pages.users.active': '活跃',
  'pages.users.disabled': '已禁用',
  'pages.users.unverified': '未验证',
  'pages.users.roles': '角色',
  'pages.users.rolesInfo': '用户角色和权限',
  'pages.users.strategy': '策略',
  'pages.users.strategyInfo': '用户的连接策略',
  'pages.users.group': '组',
  'pages.users.groupInfo': '用户组分配',
  'pages.users.groupName': '设备组',
  'pages.users.invite': '邀请用户',
  'pages.users.password': '密码',
  'pages.users.isAdmin': '管理员',
  'pages.users.normalUser': '普通用户',
  'pages.users.statusInfo': '用户账户状态',
  'pages.users.edit': '编辑用户',
  'pages.users.updateSuccess': '用户已更新',
  'pages.users.updateFailed': '更新用户失败',
  'pages.users.security': '安全',
  'pages.users.securitySettings': '安全设置',
  'pages.users.securityUpdateSuccess': '安全设置已更新',
  'pages.users.securityUpdateFailed': '更新安全设置失败',
  'pages.users.tfaEnforce': '强制双因素认证',
  'pages.users.emailVerification': '要求邮箱验证',
  'pages.users.forceLogout': '登出',
  'pages.users.forceLogoutSuccess': '强制登出成功',
  'pages.users.forceLogoutFailed': '强制登出失败',
  'pages.users.thirdAuthType': '认证类型',
  'pages.users.createdAt': '创建时间',
  'pages.users.batchEnable': '批量启用',
  'pages.users.batchDisable': '批量禁用',
  'pages.users.batchForceLogout': '批量强制登出',
  'pages.users.batchEnableConfirm': '确定要启用选中的用户吗？',
  'pages.users.batchDisableConfirm': '确定要禁用选中的用户吗？',
  'pages.users.batchForceLogoutConfirm': '确定要强制登出选中的用户吗？',
  'pages.users.batchEnableSuccess': '成功启用 {count} 个用户',
  'pages.users.batchEnableFailed': '启用用户失败',
  'pages.users.batchEnablePartialFailed':
    '成功启用 {success} 个用户，{failed} 个失败',
  'pages.users.batchDisableSuccess': '成功禁用 {count} 个用户',
  'pages.users.batchDisableFailed': '禁用用户失败',
  'pages.users.batchDisablePartialFailed':
    '成功禁用 {success} 个用户，{failed} 个失败',
  'pages.users.batchForceLogoutSuccess': '批量强制登出成功',
  'pages.users.batchForceLogoutFailed': '批量强制登出失败',
  'pages.dashboard.totalUsers': '用户总数',
  'pages.dashboard.activeUsers': '活跃用户',
  'pages.dashboard.totalDevices': '设备总数',
  'pages.dashboard.onlineDevices': '在线设备',
  'pages.dashboard.offlineDevices': '离线设备',
  'pages.dashboard.todayConnections': '今日连接',
  'pages.dashboard.activeConnections': '活跃连接',
  'pages.dashboard.avgDuration': '平均时长',
  'pages.dashboard.totalAlarms': '告警总数',
  'pages.dashboard.criticalAlarms': '严重告警',
  'pages.dashboard.userDistribution': '用户分布',
  'pages.dashboard.adminUsers': '管理员',
  'pages.dashboard.normalUsers': '普通用户',
  'pages.dashboard.deviceDistribution': '设备分布',
  'pages.dashboard.connectionAnalysis': '连接分析',
  'pages.dashboard.successRate': '成功率',
  'pages.dashboard.failureCount': '失败次数',
  'pages.dashboard.totalDuration': '总时长',
  'pages.dashboard.fileTransfer': '文件传输',
  'pages.dashboard.transferredToday': '今日传输',
  'pages.dashboard.totalSize': '总大小',
  'pages.dashboard.uploadCount': '上传次数',
  'pages.dashboard.downloadCount': '下载次数',
  'pages.dashboard.systemStatus': '系统状态',
  'pages.dashboard.uptime': '运行时间',
  'pages.dashboard.trendData': '趋势数据',
  'pages.dashboard.connectionTrend': '连接趋势',
  'pages.dashboard.userActiveTrend': '用户活跃趋势',
  'pages.dashboard.alarmTrend': '告警趋势',
  'pages.dashboard.recentEvents': '最近事件',
  'pages.dashboard.user': '用户',
  'pages.dashboard.device': '设备',
  'pages.dashboard.duration': '时长',
  'pages.dashboard.startTime': '开始时间',
  'pages.dashboard.eventType': '类型',
  'pages.dashboard.action': '动作',
  'pages.dashboard.target': '目标',
  'pages.dashboard.status': '状态',
  'pages.dashboard.time': '时间',
  'pages.common.pleaseEnterName': '请输入名称',
  'pages.common.pleaseEnterId': '请输入 ID',
  'pages.common.pleaseEnterTagName': '请输入标签名称',
  'pages.common.pleaseEnterUsername': '请输入用户名',
  'pages.common.pleaseEnterEmail': '请输入邮箱',
  'pages.common.pleaseEnterValidEmail': '请输入有效的邮箱地址',
  'pages.common.pleaseEnterPassword': '请输入密码',
  'pages.common.pleaseEnterRoleName': '请输入角色名称',
  'pages.common.id': 'ID',
  'pages.dashboard.min': '分钟',
  'pages.dashboard.cpu': 'CPU',
  'pages.dashboard.memory': '内存',
  'pages.dashboard.disk': '磁盘',
  'pages.dashboard.inactive': '不活跃',
  'pages.dashboard.onlineRate': '在线率',
  'pages.dashboard.connectionCount': '连接数',
  'pages.dashboard.newUsers': '新增用户',
  'pages.dashboard.7days': '7 天',
  'pages.dashboard.30days': '30 天',
  'pages.dashboard.90days': '90 天',
  'pages.dashboard.noData': '暂无数据',
  'pages.dashboard.resourceDistribution': '资源分布',
  'pages.dashboard.operationAnalysis': '运营分析',
  'pages.smtp.title': 'SMTP 配置',
  'pages.smtp.description': '配置 SMTP 邮件服务器用于发送系统通知邮件',
  'pages.smtp.host': '服务器地址',
  'pages.smtp.hostPlaceholder': '请输入 SMTP 服务器地址',
  'pages.smtp.port': '端口',
  'pages.smtp.portPlaceholder': '请输入端口号',
  'pages.smtp.secure': '使用 SSL/TLS',
  'pages.smtp.secureHelp':
    '启用安全连接（通常端口 465 使用 SSL，端口 587 使用 TLS）',
  'pages.smtp.user': '用户名',
  'pages.smtp.userPlaceholder': '请输入 SMTP 认证用户名',
  'pages.smtp.password': '密码',
  'pages.smtp.passwordPlaceholder': '请输入 SMTP 认证密码',
  'pages.smtp.from': '发件人邮箱',
  'pages.smtp.fromPlaceholder': '请输入发件人邮箱地址',
  'pages.smtp.enabled': '启用配置',
  'pages.smtp.enabledHelp': '启用后将使用此配置发送系统邮件',
  'pages.smtp.testConnection': '测试连接',
  'pages.smtp.testSuccess': 'SMTP 连接测试成功',
  'pages.smtp.testFailed': 'SMTP 连接测试失败',
  'pages.smtp.saveSuccess': 'SMTP 配置保存成功',
  'pages.smtp.saveFailed': 'SMTP 配置保存失败',
  'pages.smtp.createdAt': '创建时间',
  'pages.smtp.updatedAt': '更新时间',
  'pages.addressBook.color': '颜色',
  'pages.addressBook.deviceInfo': '用户名@设备名',
  'pages.addressBook.manageTags': '管理标签',
  'pages.addressBook.newTagName': '新标签名称',
  'pages.addressBook.peerUpdateFailed': '更新对等端失败',
  'pages.addressBook.peerUpdated': '对等端已更新',
  'pages.addressBook.renameTag': '重命名标签',
  'pages.addressBook.selectTags': '选择标签',
  'pages.addressBook.tagColorUpdateFailed': '更新标签颜色失败',
  'pages.addressBook.tagRenameFailed': '重命名标签失败',
  'pages.addressBook.tagRenamed': '标签已重命名',
  'pages.addressBook.untagged': '未标记',
  'pages.common.cancel': '否',
  'pages.common.confirm': '是',
  'pages.common.enterDescription': '请输入描述',
  'pages.common.rename': '重命名',
  'pages.common.save': '保存',
  'pages.customClients.enterName': '请输入客户端名称',
  'pages.settings.chinese': '中文',
  'pages.settings.english': '英文',
  'pages.settings.enterAdminEmail': '请输入管理员邮箱',
  'pages.settings.enterSiteName': '请输入站点名称',
  'pages.settings.logError': '错误',
  'pages.settings.logInfo': '信息',
  'pages.settings.logWarning': '警告',
  'pages.userGroups.enterName': '请输入组名称',
  'pages.users.admin': '管理员',
  'pages.users.me': '我',
  'pages.oidcProviders.list': 'OIDC 提供商列表',
  'pages.oidcProviders.sort': '排序',
  'pages.oidcProviders.name': '提供商名称',
  'pages.oidcProviders.type': '类型',
  'pages.oidcProviders.issuer': '发行者 URL',
  'pages.oidcProviders.clientId': '客户端 ID',
  'pages.oidcProviders.clientSecret': '客户端密钥',
  'pages.oidcProviders.scope': '授权范围',
  'pages.oidcProviders.authorizationEndpoint': '授权端点',
  'pages.oidcProviders.tokenEndpoint': '令牌端点',
  'pages.oidcProviders.userinfoEndpoint': '用户信息端点',
  'pages.oidcProviders.jwksUri': 'JWKS 端点',
  'pages.oidcProviders.enabled': '启用状态',
  'pages.oidcProviders.priority': '优先级',
  'pages.oidcProviders.endpointConfig': '端点配置',
  'pages.oidcProviders.create': '创建提供商',
  'pages.oidcProviders.edit': '编辑提供商',
  'pages.oidcProviders.test': '测试',
  'pages.oidcProviders.testResult': '测试连接结果',
  'pages.oidcProviders.discoveredEndpoints': '自动发现的端点',
  'pages.oidcProviders.enterName': '请输入提供商名称',
  'pages.oidcProviders.enterIssuer': '请输入发行者 URL',
  'pages.oidcProviders.enterClientId': '请输入客户端 ID',
  'pages.oidcProviders.enterClientSecret': '请输入客户端密钥',
  'pages.oidcProviders.enterEndpoint': '留空则自动发现',
  'pages.oidcProviders.createSuccess': 'OIDC 提供商已创建',
  'pages.oidcProviders.createFailed': '创建 OIDC 提供商失败',
  'pages.oidcProviders.updateSuccess': 'OIDC 提供商已更新',
  'pages.oidcProviders.updateFailed': '更新 OIDC 提供商失败',
  'pages.oidcProviders.deleteSuccess': 'OIDC 提供商已删除',
  'pages.oidcProviders.deleteFailed': '删除 OIDC 提供商失败',
  'pages.oidcProviders.deleteConfirm': '确定要删除此提供商吗？',
  'pages.oidcProviders.enableSuccess': 'OIDC 提供商已启用',
  'pages.oidcProviders.enableFailed': '启用 OIDC 提供商失败',
  'pages.oidcProviders.disableSuccess': 'OIDC 提供商已禁用',
  'pages.oidcProviders.disableFailed': '禁用 OIDC 提供商失败',
  'pages.oidcProviders.enableConfirm': '确定要启用此提供商吗？',
  'pages.oidcProviders.disableConfirm': '确定要禁用此提供商吗？',
  'pages.oidcProviders.testFailed': '测试 OIDC 连接失败',
  'pages.oidcProviders.fetchDetailFailed': '获取提供商详情失败',
  'pages.oidcProviders.sortFailed': '更新提供商排序失败',
  'pages.account.tab.basic': '基本信息',
  'pages.account.tab.avatar': '头像设置',
  'pages.account.tab.security': '安全设置',
  'pages.account.basicInfo.title': '基本信息',
  'pages.account.basicInfo.displayName': '显示名称',
  'pages.account.basicInfo.displayNamePlaceholder': '请输入显示名称',
  'pages.account.basicInfo.name': '用户名',
  'pages.account.basicInfo.email': '邮箱',
  'pages.account.basicInfo.note': '备注',
  'pages.account.basicInfo.updateSuccess': '用户信息已更新',
  'pages.account.basicInfo.updateFailed': '更新用户信息失败',
  'pages.account.avatar.title': '头像设置',
  'pages.account.avatar.hint':
    '支持 JPG、PNG、WebP 格式，最大 2MB，将自动缩放为 256x256',
  'pages.account.avatar.upload': '上传头像',
  'pages.account.avatar.delete': '删除头像',
  'pages.account.avatar.deleteConfirm': '确定要删除头像吗？',
  'pages.account.avatar.uploadSuccess': '头像上传成功',
  'pages.account.avatar.uploadFailed': '头像上传失败',
  'pages.account.avatar.deleteSuccess': '头像已删除',
  'pages.account.avatar.deleteFailed': '删除头像失败',
  'pages.account.avatar.fileTooLarge': '文件大小不能超过 2MB',
  'pages.account.avatar.invalidFormat': '仅支持 JPG、PNG、WebP 格式',
  'pages.account.security.title': '安全设置',
  'pages.account.security.2faStatus': '双因素认证状态',
  'pages.account.security.2faAction': '操作',
  'pages.account.security.enabled': '已启用',
  'pages.account.security.disabled': '未启用',
  'pages.account.security.enable2FA': '启用 2FA',
  'pages.account.security.disable2FA': '禁用 2FA',
  'pages.account.security.setup2FA': '设置双因素认证',
  'pages.account.security.setupFailed': '设置 2FA 失败',
  'pages.account.security.scanQRCode':
    '请使用认证器应用扫描二维码，然后输入验证码完成绑定。',
  'pages.account.security.secretKey': '密钥',
  'pages.account.security.verificationCode': '验证码',
  'pages.account.security.enterCode': '请输入验证码',
  'pages.account.security.verifyAndEnable': '验证并启用',
  'pages.account.security.enableSuccess': '2FA 已启用',
  'pages.account.security.enableFailed': '启用 2FA 失败',
  'pages.account.security.currentCode': '当前验证码',
  'pages.account.security.confirmDisable': '确认禁用',
  'pages.account.security.disableSuccess': '2FA 已禁用',
  'pages.account.security.disableFailed': '禁用 2FA 失败',
  'pages.account.security.password': '登录密码',
  'pages.account.security.passwordSet': '已设置',
  'pages.account.security.passwordNotSet': '未设置',
  'pages.account.security.changePassword': '修改密码',
  'pages.account.security.currentPassword': '当前密码',
  'pages.account.security.enterCurrentPassword': '请输入当前密码',
  'pages.account.security.newPassword': '新密码',
  'pages.account.security.enterNewPassword': '请输入新密码（至少6位）',
  'pages.account.security.confirmNewPassword': '确认新密码',
  'pages.account.security.confirmNewPasswordPlaceholder': '请再次输入新密码',
  'pages.account.security.passwordMinLength': '密码长度不能少于6位',
  'pages.account.security.passwordMismatch': '两次输入的密码不一致',
  'pages.account.security.changePasswordSuccess': '密码修改成功',
  'pages.account.security.changePasswordFailed': '密码修改失败',
  'pages.account.security.thirdPartyUser': '第三方登录用户不支持修改密码',
  'pages.account.security.noPasswordUser': '当前账户未设置密码，无法修改',
  'pages.ldap.title': 'LDAP 配置',
  'pages.ldap.description':
    '配置 LDAP/Active Directory 认证。启用后，用户将通过 LDAP 服务器进行身份验证。',
  'pages.ldap.urls': '服务器地址',
  'pages.ldap.urlsRequired': '请输入至少一个 LDAP 服务器地址',
  'pages.ldap.urlPlaceholder': '例如 ldaps://ad.example.com:636',
  'pages.ldap.addUrl': '添加服务器地址',
  'pages.ldap.bindDN': '绑定 DN',
  'pages.ldap.bindDNRequired': '请输入服务账号绑定 DN',
  'pages.ldap.bindDNPlaceholder':
    '例如 CN=svc-ldap,OU=ServiceAccounts,DC=example,DC=com',
  'pages.ldap.bindCredentials': '绑定密码',
  'pages.ldap.bindCredentialsRequired': '请输入服务账号密码',
  'pages.ldap.bindCredentialsPlaceholder': '请输入服务账号密码',
  'pages.ldap.searchBase': '搜索基础 DN',
  'pages.ldap.searchBaseRequired': '请输入搜索基础 DN',
  'pages.ldap.searchBasePlaceholder': '例如 DC=example,DC=com',
  'pages.ldap.searchFilter': '搜索过滤器',
  'pages.ldap.searchFilterRequired': '请输入搜索过滤器',
  'pages.ldap.searchFilterHelp':
    '使用 {{username}} 作为用户名占位符。AD: (sAMAccountName={{username}})，OpenLDAP: (uid={{username}})',
  'pages.ldap.searchFilterPlaceholder': '例如 (sAMAccountName={{username}})',
  'pages.ldap.searchAttributes': '搜索属性',
  'pages.ldap.searchAttributePlaceholder':
    '例如 dn, sAMAccountName, mail, displayName',
  'pages.ldap.addAttribute': '添加属性',
  'pages.ldap.groupSearchBase': '组搜索基础 DN',
  'pages.ldap.groupSearchBasePlaceholder': '例如 OU=Groups,DC=example,DC=com',
  'pages.ldap.groupSearchFilter': '组搜索过滤器',
  'pages.ldap.groupSearchFilterHelp':
    '使用 {{dn}} 作为用户 DN 占位符。例如 (member={{dn}})',
  'pages.ldap.groupSearchFilterPlaceholder': '例如 (member={{dn}})',
  'pages.ldap.adminGroups': '管理员组',
  'pages.ldap.adminGroupsHelp':
    '属于这些 LDAP 组的用户将被映射为管理员（大小写不敏感匹配）',
  'pages.ldap.adminGroupPlaceholder':
    '例如 CN=Admins,OU=Groups,DC=example,DC=com',
  'pages.ldap.addAdminGroup': '添加管理员组',
  'pages.ldap.tlsOptions': 'TLS 选项',
  'pages.ldap.tlsCa': 'CA 证书（PEM 格式）',
  'pages.ldap.tlsCaPlaceholder': '-----BEGIN CERTIFICATE-----\n...',
  'pages.ldap.tlsCert': '客户端证书（PEM 格式）',
  'pages.ldap.tlsCertPlaceholder': '-----BEGIN CERTIFICATE-----\n...',
  'pages.ldap.tlsKey': '客户端私钥（PEM 格式）',
  'pages.ldap.tlsKeyPlaceholder': '-----BEGIN PRIVATE KEY-----\n...',
  'pages.ldap.tlsServername': 'SNI 服务器名称',
  'pages.ldap.tlsServernamePlaceholder': 'TLS 服务器名称指示',
  'pages.ldap.enabled': '启用 LDAP 认证',
  'pages.ldap.enabledHelp':
    '启用后，用户将通过 LDAP 服务器进行身份验证。已关联 LDAP 的用户无论此设置如何，始终使用 LDAP 认证。',
  'pages.ldap.testConnection': '测试连接',
  'pages.ldap.testSuccess': 'LDAP 连接测试成功',
  'pages.ldap.testFailed': 'LDAP 连接测试失败',
  'pages.ldap.saveSuccess': 'LDAP 配置保存成功',
  'pages.ldap.saveFailed': 'LDAP 配置保存失败',
  'pages.ldap.createdAt': '创建时间',
  'pages.ldap.updatedAt': '更新时间',
  'pages.nexus.repoRequired': '需要仓库互动',
  'pages.nexus.repoRequiredDesc':
    '您需要对 databk/rustdesk-console GitHub 仓库进行 Star、Fork 或 Watch 操作后才能生成自定义客户端。操作后最长需等待 5 分钟缓存刷新。',
  'pages.nexus.goToRepo': '前往 GitHub 仓库',
  'pages.nexus.buildList': '构建历史',
  'pages.nexus.createBuild': '创建新客户端',
  'pages.nexus.noBuilds': '暂无构建记录',
  'pages.nexus.createBuildTitle': '创建自定义客户端',
  'pages.nexus.customConfig': '定制配置',
  'pages.nexus.serverConfig': '服务器配置',
  'pages.nexus.password': '密码',
  'pages.nexus.passwordPlaceholder': '请输入密码',
  'pages.nexus.salt': '盐值',
  'pages.nexus.saltPlaceholder': '请输入盐值',
  'pages.nexus.connType': '连接类型',
  'pages.nexus.disableInstallation': '禁用安装功能',
  'pages.nexus.disableSettings': '禁用设置功能',
  'pages.nexus.disableAccount': '禁用账户功能',
  'pages.nexus.disableAb': '禁用AB功能',
  'pages.nexus.disableTcpListen': '禁用TCP监听',
  'pages.nexus.rendezvousServer': 'ID 服务器',
  'pages.nexus.relayServer': '中继服务器',
  'pages.nexus.key': '密钥',
  'pages.nexus.apiServer': 'API 服务器',
  'pages.nexus.overrideSettings': '覆盖设置',
  'pages.nexus.defaultSettings': '默认设置',
  'pages.nexus.settingType': '配置类型',
  'pages.nexus.deleteBuildConfirm': '确定要删除此构建记录吗？',
  'pages.nexus.deleteSuccess': '构建记录已删除',
  'pages.nexus.deleteFailed': '删除构建记录失败',
  'pages.nexus.pollingBuildStatus': '正在轮询构建状态...',
  'pages.nexus.uuid': 'UUID',
  'pages.nexus.concurrentLimit': '同时只能有一个构建任务',
  'pages.nexus.os': '操作系统',
  'pages.nexus.arch': '架构',
  'pages.nexus.appName': '应用名称',
  'pages.nexus.enterAppName': '请输入应用名称',
  'pages.nexus.appNamePlaceholder': '例如 my-rustdesk',
  'pages.nexus.appNameHint': '仅允许英文字母',
  'pages.nexus.submitBuild': '提交构建',
  'pages.nexus.bindSuccess': 'Github 账号绑定成功',
  'pages.nexus.bindFailed': 'Github 账号绑定失败',
  'pages.nexus.createLoginFailed': '创建登录会话失败',
  'pages.nexus.unbindConfirm': '解绑 Github 账号',
  'pages.nexus.unbindConfirmContent':
    '确定要解绑 Github 账号吗？解绑后需要重新绑定才能生成自定义客户端。',
  'pages.nexus.unbindSuccess': 'Github 账号已解绑',
  'pages.nexus.unbindFailed': '解绑 Github 账号失败',
  'pages.nexus.tokenExpired': 'Github Token 已过期',
  'pages.nexus.tokenExpiredDesc':
    'Github 账号 {username} 的 Token 已过期，请重新绑定。',
  'pages.nexus.rebind': '重新绑定 Github 账号',
  'pages.nexus.bindTitle': '绑定 Github 账号',
  'pages.nexus.bindDesc':
    '您需要绑定 GitHub 账号才能生成自定义客户端。点击下方按钮通过 GitHub 授权。',
  'pages.nexus.bindGithub': '通过 GitHub 授权',
  'pages.nexus.unbind': '解绑',
  'pages.nexus.repoInteractionRequired':
    '请先对 databk/rustdesk-console 仓库进行 Star、Fork 或 Watch 操作。操作后最长需等待 5 分钟缓存刷新。',
  'pages.nexus.buildAlreadyRunning': '已有一个正在进行的构建任务',
  'pages.nexus.generateFailed': '提交构建请求失败',
  'pages.nexus.downloadFailed': '下载自定义客户端失败',
  'pages.nexus.download': '下载',
  'pages.nexus.buildAgain': '再次构建',
  'pages.nexus.status': '状态',
  'pages.nexus.statusPending': '等待构建',
  'pages.nexus.statusPendingDesc': '构建请求已提交，正在等待处理...',
  'pages.nexus.statusBuilding': '构建中',
  'pages.nexus.statusBuildingDesc':
    'GitHub Actions 正在构建自定义客户端，可能需要几分钟...',
  'pages.nexus.statusCompleted': '构建完成',
  'pages.nexus.statusCompletedDesc': '自定义客户端已就绪，可以下载。',
  'pages.nexus.statusFailed': '构建失败',
  'pages.nexus.statusFailedDesc': '构建过程遇到错误。',
  'pages.nexus.statusCancelled': '构建已取消',
  'pages.nexus.statusCancelledDesc':
    '构建被取消，通常是因为您取消了对仓库的 Star/Fork/Watch。',
  'pages.nexus.bindWhyLogin':
    '通过 GitHub 身份验证，我们可以确认您是真实用户，从而防止构建资源被自动化滥用。我们仅获取您的公开信息——不会请求访问您的仓库、个人数据或任何其他权限。',
  'pages.nexus.repoWhyInteract':
    '我是一名高中生，利用课余时间开发这个项目。您的 Star、Fork 或 Watch 对我意义重大——这不仅是对我持续开发的鼓励，也有助于我的大学申请。这是我所请求的唯一回报。非常感谢您的支持！',
};
